import { type FC, type ReactNode } from "react";
import { generatePath } from "react-router-dom";

import { AuthState } from "@snapchat/sso-auth";

import { AbsoluteRoute } from "../../core/routes/absoluteRoutes";
import { useAuthState } from "../../core/sso-auth";
import { isLocal } from "../../shared/constants";

import { PageContentSpinner } from "./PageContentSpinner";

const makeRedirectReferrer = (origin: string, pathname: string, search: string) => {
    if (pathname.startsWith("/submit")) {
        const [_, submissionId] = pathname.slice(1).split("/");
        const initialSubmissionPath = generatePath(AbsoluteRoute.SUBMIT, {
            submissionId: submissionId ?? "",
        });

        return `${origin}${initialSubmissionPath}${search}`;
    }

    if (pathname.startsWith("/camera-kit/onboarding") || pathname.startsWith("/assets")) {
        return `${origin}${pathname}${search}`;
    }

    return origin;
};

const SSOAuthGuard: FC<{ children?: ReactNode }> = ({ children }) => {
    const { origin, pathname, search } = window.location;

    const redirectReferrer = makeRedirectReferrer(origin, pathname, search);

    const authState = useAuthState(redirectReferrer);

    switch (authState) {
        case AuthState.Authenticated:
            return <>{children}</>;
        case AuthState.NonAuthenticated: {
            return <>Auth redirect...</>;
        }
        default:
            return <PageContentSpinner />;
    }
};

export const AuthGuard: FC<{ children?: ReactNode }> = ({ children }) => {
    if (isLocal()) {
        return <>{children}</>;
    }

    return <SSOAuthGuard>{children}</SSOAuthGuard>;
};
